import { useEffect } from 'react'
import { useEditorStore } from '../stores/editorStore'
import { useFileSystem } from './useFileSystem'

export function useKeyboardShortcuts() {
  const { saveCurrentFile, importFile, exportCurrentFile } = useFileSystem()

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const isCtrl = e.ctrlKey || e.metaKey

      if (isCtrl && e.key === 's') {
        e.preventDefault()
        saveCurrentFile()
      }

      if (isCtrl && e.key === 'o') {
        e.preventDefault()
        importFile()
      }

      if (isCtrl && e.key === 'e') {
        e.preventDefault()
        exportCurrentFile()
      }
    }

    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [saveCurrentFile, importFile, exportCurrentFile])
}
